const state = {
    me: {},
    users: []
}

export default state
